import {Directive, ElementRef, EventEmitter, Input, Output, Renderer2} from '@angular/core';
import {CONFIG} from "../app/config";

@Directive({
    selector: '[verMais]',
    host: {},
    providers: []
})
export class VerMaisDirective {

    config: any;

    display: string;
    innerHTML: string;

    @Input('verMais') verMais: number = 200;
    @Input('verBttn') verBttn: boolean = true;

    @Input('verMaisHtml')
    set reload(data: string) {
        this.dataSetted(data);
    }

    @Output('verMais-click') private _click: EventEmitter<any> = new EventEmitter();

    private _element: HTMLElement;

    constructor(public element: ElementRef, public renderer: Renderer2) {

        this.config = CONFIG;
        this._element = element.nativeElement;

        // this._element.style.display = 'none';

    }

    ngAfterViewInit() {

        //

    }

    dataSetted(data) {

        this._element.innerHTML = data;

        // this.display = this._element.style.display;
        this.innerHTML = this._element.innerHTML;

        while (this.innerHTML.indexOf('\r\n') >= 0) {
            this.innerHTML = this.innerHTML.replace('\r\n', '');
        }

        while (this.innerHTML.indexOf('\n') >= 0) {
            this.innerHTML = this.innerHTML.replace('\n', '');
        }

        while (this.innerHTML.indexOf('\'') >= 0) {
            this.innerHTML = this.innerHTML.replace('\'', '');
        }

        let pos = this.verMais;
        while (this._element.innerHTML[pos-1] && this._element.innerHTML[pos-1] != ' ') {
            pos++;
        }

        this._element.innerHTML = this._element.innerText.substr(0, pos);


        if (this.verBttn) this._element.innerHTML += ' <button style="color: ' + this.config.colors.CorRoxa + '" onclick="this.parentElement.innerHTML = \'' + this.innerHTML + '\';" (click)="_emitClick()">ver mais</button>';
      //this._element.innerHTML += ' <button style="color: ' + this.config.colors.CorRoxa + '" onclick="this._emitClick();">ver mais</button>';

        this._element.style.display = this.display;

    }

    _emitClick() {

        this._click.emit(null);

    }

}



// WEBPACK FOOTER //
// ./src/directives/ver-mais.ts